import { saveAs } from "file-saver"
import * as Rx from "rxjs"
import { map, retry } from "rxjs/operators"
import { request } from "../../utils/http"

export const downloadReport = (
    headers: Record<string, any>,
    reportAgendaApiRoute: string,
    parameters: Record<string, any>
) =>
    Rx.defer(() =>
        request({
            method: "GET",
            path: `/report/${reportAgendaApiRoute}`,
            parameters: parameters,
            headers: headers,
            withResponseHeaders: true,
        })
    ).pipe(
        map(({ responseBody, responseHeaders }) => {
            const filename = responseHeaders.get("content-disposition").split("filename=")[1]
            const filetype = responseHeaders.get("Content-Type")
            const blob = new Blob([responseBody], {
                type: filetype,
            })
            return saveAs(blob, filename)
        }),
        retry(3)
    )
